import { Hash } from 'lucide-react';

interface ItemIdCellProps {
  value: number | string | null;
  readOnly?: boolean;
}

export function ItemIdCell({ value }: ItemIdCellProps) {
  if (!value) {
    return <span className="text-gray-400 text-sm">-</span>;
  }

  return (
    <div className="flex items-center gap-1 text-gray-600 font-mono">
      <Hash className="w-3 h-3" />
      <span className="font-semibold">{value}</span>
    </div>
  );
}
